import { j as e } from "../../../../../../../jsx-runtime.BREq8dyb.js";
import { Stack as r } from "@mui/joy";
import { memo as t } from "react";
import o from "../../../../DqDatasetSyncControlledInput/DqDatasetSyncControlledInput.js";
import a from "../../labels/ConfigurationLabel/ConfigurationLabel.js";
const l = t(() => /* @__PURE__ */ e.jsxs(r, { children: [
  /* @__PURE__ */ e.jsx(a, {}),
  /* @__PURE__ */ e.jsx(o, { label: "Seat ID", name: "splicky.seatId", placeholder: 'e.g. "7165"' }),
  /* @__PURE__ */ e.jsx(o, { label: "Audience name", name: "splicky.userDefinedAudienceName", placeholder: 'e.g. "DCR Audience"' })
] }));
l.displayName = "SplickyFormControls";
export {
  l as default
};
//# sourceMappingURL=SplickyFormControls.js.map
